<mat-card class="animate__animated animate__fadeIn">
    <app-card-header title="Reports" subtitle="Research Personnel Report"></app-card-header>
    <mat-card-content class="p-3">
        <div class="search-div">
            <form class="filters" [formGroup]="form" (ngSubmit)="fetch()">

                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by First Name</mat-label>
                            <input matInput formControlName="firstName" placeholder="First name" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by Last Name</mat-label>
                            <input matInput formControlName="lastName" placeholder="Last name" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by Email</mat-label>
                            <input matInput formControlName="email" placeholder="Email" />
                        </mat-form-field>
                    </div>
                     <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by Phone</mat-label>
                            <input matInput formControlName="phone" placeholder="phone" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by Irb Number</mat-label>
                            <input matInput formControlName="irbNumber" placeholder="Irb Number" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-9">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by Study Title</mat-label>
                            <input matInput formControlName="studyTitle" placeholder="Study Title" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by Institution</mat-label>
                            <input type="text" matInput formControlName="institutionId"
                                [matAutocomplete]="institutionAutoComplete">
                            <mat-autocomplete #institutionAutoComplete="matAutocomplete" [displayWith]="displayFn">
                                <mat-option *ngFor="let institution of filteredInstitutions$ | async"
                                    [value]="institution">
                                    {{institution.name}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by Role</mat-label>
                            <input type="text" matInput formControlName="roleId"
                                [matAutocomplete]="roleAutoComplete">
                            <mat-autocomplete #roleAutoComplete="matAutocomplete" [displayWith]="displayFn">
                                <mat-option *ngFor="let role of filteredRoles$ | async"
                                    [value]="role">
                                    {{role.name}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                     <div class="col-md-6">
                        <mat-form-field appearance="fill">
                            <mat-label>Choose Start and End Date Range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input formControlName="startDate" matStartDate placeholder="Start date">
                                <input formControlName="endDate" matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                    </div>


                </div>
                <!--Principal Investigator-->
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by PI First Name</mat-label>
                            <input matInput formControlName="principalInvestigatorFirstName" placeholder="PI FirstName" />
                        </mat-form-field>
                    </div>
                     <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by PI Last Name</mat-label>
                            <input matInput formControlName="principalInvestigatorLastName" placeholder="PI LastName" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by PI Email</mat-label>
                            <input matInput formControlName="principalInvestigatorEmail" placeholder="PI Email" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Search by PI Phone</mat-label>
                            <input matInput formControlName="principalInvestigatorPhone" placeholder="PI Phone" />
                        </mat-form-field>
                    </div>

                </div>


                <div class="d-flex justify-content-center mt-3">
                    <button type="button" class="mr-3" mat-stroked-button color="warn" (click)="reset()">Clear
                        Search</button>
                    <button class="mr-3" mat-stroked-button color="primary" type="submit"
                        (click)="fetch()">Submit</button>
                    <div class="button-container">
                        <span class="spinner-container" *ngIf="excelLoading">
                            <mat-spinner diameter="24"></mat-spinner>
                        </span>
                        <button mat-stroked-button color="accent" type="button" [disabled]="excelLoading"
                            (click)="downloadExcel()">Download
                            Excel</button>
                    </div>
                </div>
            </form>
        </div>

    </mat-card-content>
    <div *ngIf="tableLoading" style="position: absolute; right: 50%; top: 35%;">
        <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
    <!-- TOP PAGER -->
    <mat-paginator [length]="total" [pageIndex]="reportService.pageIndex - 1" [pageSize]="reportService.pageSize"
        [pageSizeOptions]="[10,50,100]" (page)="onPage($event)">
    </mat-paginator>


    <div class="table-container" [class.loading]="tableLoading">
        <table mat-table [dataSource]="data" matSort (matSortChange)="onSortChange($event)">
            <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">Last Name</th>
                <td mat-cell *matCellDef="let r">{{ r.lastName }}</td>
            </ng-container>

            <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">First Name</th>
                <td mat-cell *matCellDef="let r">{{ r.firstName }}</td>
            </ng-container>



            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="email">Email</th>
                <td mat-cell *matCellDef="let r">
                    <a *ngIf="r.email" [href]="'mailto:' + r.email">{{ r.email }}</a>
                </td>
            </ng-container>

            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="role">Role</th>
                <td mat-cell *matCellDef="let r">{{ r.role }}</td>
            </ng-container>

            <ng-container matColumnDef="institution">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="institution">Institution</th>
                <td mat-cell *matCellDef="let r">{{ r.institution }}</td>
            </ng-container>

            <ng-container matColumnDef="irbNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>IRB Number </th>
                <td mat-cell *matCellDef="let element">
                    <a [routerLink]="['/protocol', element.protocolId]" (click)="view(element.protocolId)"
                        class="text-link">
                        {{ element.irbNumber || 'View' }}
                    </a>

                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let r; columns: displayedColumns"></tr>
        </table>

        <!-- BOTTOM PAGER -->
        <mat-paginator [length]="total" [pageIndex]="reportService.pageIndex - 1" [pageSize]="reportService.pageSize"
            [pageSizeOptions]="[10,50,100]" (page)="onPage($event)">
        </mat-paginator>
    </div>
</mat-card>